import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Legacy /login rotası. Unified login artık Home.jsx (/) içinde.
 * Eski linkler (e.g. /login?role=admin) bozulmasın diye burada
 * yönlendirme yapıyoruz.
 */
export default function Login() {
  return <Navigate to="/" replace />;
}
